/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Card, { CardSection } from '../../components/card/Card';

import PasswordInput from '../../components/PasswordInput';
import { CheckboxInput } from '../../components/CheckboxInput';
import { Caption } from '../../components/Text';
import Spacer from '../../components/Spacer';
import { TextLink } from '../../components/TextLink';
import ContentWrapper from '../../components/ContentWrapper';

const LoginPassword = (props) => (
  <ContentWrapper>
    <Card>
      <CardSection>
        <form onSubmit={props.onSubmit}>
          <div>
            <PasswordInput
              value={props.password}
              onChange={props.onChangePassword}
              onFocus={props.onFocus}
              isInvalid={props.isPasswordValid}
              name="password"
              label={<FormattedMessage id="loginPwd.password.field.label" />}
              regulatHint={<FormattedMessage id="loginPwd.email.field.label" values={{ string1: props.email }} />}
              invalidHint={props.errorMessage}
              initialFocus
            />
          </div>

          <Caption color="neutral">
            <FormattedMessage id="loginPwd.email.field.label" /> <span>{props.email}</span>
          </Caption>

          { props.forceKeepSignedIn ? null : <Spacer size="20">
            <CheckboxInput
              value={true}
              name="trustBrowser"
              onChange={props.toggleKeepSignedIn}
              checked={props.keepSignedIn}
              label={<FormattedMessage id="loginPwd.keepSignedIn.option.label" />}
            />
          </Spacer> }

          <input type="submit" style={{ visibility: 'hidden', float: 'right' }} />
        </form>
      </CardSection>
    </Card>

    <div className="util-application-frame-forcards-padding util-list-vertical-padding">
      <Caption>
        <TextLink onClick={props.goToForgotPassword} colorClass="font-color-profile">
          <FormattedMessage id="loginPwd.forgotPassword.button.label" />
        </TextLink>
      </Caption>
    </div>
  </ContentWrapper>
);
LoginPassword.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string,
  onChangePassword: PropTypes.func,
  toggleKeepSignedIn: PropTypes.func,
  onSubmit: PropTypes.func,
  onFocus: PropTypes.func,
  goToForgotPassword: PropTypes.func,
  isPasswordValid: PropTypes.bool,
  keepSignedIn: PropTypes.bool,
  errorMessage: PropTypes.any,
  forceKeepSignedIn: PropTypes.bool,
};

export default LoginPassword;
